/* Bundle configurator (BFE) — Smaak A. PDP-stijl varianten (kleur-swatch + foto-update),
   multi-item ATC, bundelkorting. */
if (!customElements.get('bundle-configurator')) {
  class BundleConfigurator extends HTMLElement {
    constructor() {
      super();
      this.fmt = new Intl.NumberFormat(Shopify.locale, { style: 'currency', currency: Shopify.currency.active });
    }

    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-bundle-card]'));
      this.subtotalEl = this.querySelector('[data-bundle-subtotal]');
      this.finalEl = this.querySelector('[data-bundle-final]');
      this.savingsEl = this.querySelector('[data-bundle-savings]');
      this.addBtn = this.querySelector('[data-bundle-add]');
      this.errorEl = this.querySelector('[data-bundle-error]');
      this.code = this.dataset.discountCode;
      this.pct = parseFloat(this.dataset.discountPct) || 0;
      this.soldOutText = this.dataset.soldout || '';
      this.savingsLabel = this.dataset.savingsLabel || '';

      this.cards.forEach(card => {
        card._variants = this.readVariants(card);
        card.querySelectorAll('[data-bundle-option]').forEach(input => {
          input.addEventListener('change', () =>
            this.onOptionChange(card, parseInt(input.dataset.optionIndex), input.value));
        });
        // Optioneel item (upsell): checkbox bepaalt of 'ie meetelt + in de cart komt.
        const optToggle = card.querySelector('[data-bundle-optional-toggle]');
        if (optToggle) {
          optToggle.addEventListener('change', () => {
            card.dataset.selected = optToggle.checked ? 'true' : 'false';
            this.updateTotal();
          });
        }
        this.setupAdvisorBridge(card);
        this.updateValueAvailability(card);
      });
      this.addBtn?.addEventListener('click', () => this.addAllToCart());
      this.updateTotal();
    }

    readVariants(card) {
      const json = card.querySelector('[data-bundle-variants]');
      if (!json) return [];
      try { return JSON.parse(json.textContent); } catch (e) { return []; }
    }

    // Maatadviseur-bridge: de gedeelde advisor verwacht een product-form (bestaat hier niet).
    // We koppelen z'n "toepassen"-knop aan de maat-radio van déze kaart + sluiten de modal.
    setupAdvisorBridge(card) {
      const applyBtn = card.querySelector('[data-add]');
      const sizeChip = card.querySelector('[data-result-size]');
      const modalEl = card.querySelector('x-modal');
      // De adviseur heeft in de bundel geen product-form; hij dispatcht z'n advies-
      // properties via 'size-advisor:applied'. Bewaar ze op de kaart zodat addAllToCart
      // ze meestuurt als line-item properties van dít item (analytics + order-inzicht).
      // Luister op het advisor-element zelf i.p.v. bubbling (modal kan naar body verhuizen).
      const advisorEl = card.querySelector('size-advisor-bfe');
      if (advisorEl) {
        advisorEl.addEventListener('size-advisor:applied', (e) => {
          card._advisorProps = (e.detail && e.detail.props) || null;
        });
      }
      if (!applyBtn || !sizeChip) return;
      applyBtn.addEventListener('click', () => {
        const size = (sizeChip.textContent || '').trim();
        if (size && size !== '—') this.selectSizeByText(card, size);
        if (modalEl && typeof modalEl.hide === 'function') modalEl.hide();
      });
    }

    selectSizeByText(card, size) {
      const target = size.toLowerCase();
      const inputs = card.querySelectorAll('input[data-bundle-option]');
      for (const inp of inputs) {
        if ((inp.value || '').trim().toLowerCase() === target) {
          inp.checked = true;
          this.onOptionChange(card, parseInt(inp.dataset.optionIndex), inp.value);
          return true;
        }
      }
      return false;
    }

    getSelectedOptions(card) {
      const opts = []; const seen = new Set();
      card.querySelectorAll('input[data-bundle-option]').forEach(el => {
        const i = parseInt(el.dataset.optionIndex);
        if (el.checked && !seen.has(i)) { seen.add(i); opts[i] = el.value; }
      });
      return opts;
    }

    setSelectedOptions(card, options) {
      options.forEach((val, idx) => {
        const input = card.querySelector(
          `input[data-bundle-option][data-option-index="${idx}"][value="${CSS.escape(val)}"]`);
        if (input) input.checked = true;
      });
    }

    // PDP-gedrag: probeer de huidige overige keuzes te behouden; lukt dat niet (combo bestaat
    // niet of is uitverkocht), corrigeer naar de eerste beschikbare variant met de gewijzigde waarde.
    onOptionChange(card, changedIndex, newValue) {
      const variants = card._variants || [];
      const current = this.getSelectedOptions(card);
      current[changedIndex] = newValue;

      let match = variants.find(v => v.available && v.options.every((o, i) => o === current[i]));
      if (!match) match = variants.find(v => v.available && v.options[changedIndex] === newValue);
      if (!match) match = variants.find(v => v.options[changedIndex] === newValue);
      if (!match) return;

      this.setSelectedOptions(card, match.options);
      this.applyVariant(card, match);
      this.updateValueAvailability(card);
      this.updateTotal();
    }

    applyVariant(card, variant) {
      card.dataset.selectedVariantId = variant.id;
      card.dataset.selectedVariantPrice = variant.price;
      card.dataset.available = variant.available;

      const priceEl = card.querySelector('[data-bundle-price]');
      if (priceEl) {
        const onSale = variant.compare_at && variant.compare_at > variant.price;
        // Zelfde markup als de server-render (money-filter) → geen styling-sprong bij wisselen.
        let html = '<span class="bundle-configurator-bfe__price-current' + (onSale ? ' is-sale' : '') + '">'
          + (variant.price_money || this.fmt.format(variant.price / 100)) + '</span>';
        if (onSale) {
          html += '<s class="bundle-configurator-bfe__price-compare">'
            + (variant.compare_money || this.fmt.format(variant.compare_at / 100)) + '</s>';
        }
        priceEl.innerHTML = html;
      }

      const img = card.querySelector('[data-bundle-image]');
      if (img && variant.image) { img.src = variant.image; img.removeAttribute('srcset'); }

      const availEl = card.querySelector('[data-bundle-availability]');
      if (availEl) {
        availEl.innerHTML = variant.available ? '' :
          `<span class="bundle-configurator-bfe__availability--out">${this.soldOutText}</span>`;
      }
    }

    // PDP-gedrag: kleur is de primaire as.
    // - Kleur-opties: grijs alleen uit als die kleur nergens beschikbaar is (globaal).
    // - Overige opties (maat): grijs uit als die waarde niet beschikbaar is VOOR de gekozen kleur.
    // Zo blijven kleuren vrij te kiezen, maar onbeschikbare maten worden wél doorgestreept.
    updateValueAvailability(card) {
      const variants = card._variants || [];
      const colorIdx = parseInt(card.dataset.colorIndex);
      const sel = this.getSelectedOptions(card);
      const selColor = (colorIdx >= 0) ? sel[colorIdx] : null;
      card.querySelectorAll('input[data-bundle-option]').forEach(input => {
        const idx = parseInt(input.dataset.optionIndex);
        let hasAny;
        if (idx === colorIdx || selColor === null) {
          hasAny = variants.some(v => v.available && v.options[idx] === input.value);
        } else {
          hasAny = variants.some(v => v.available && v.options[idx] === input.value && v.options[colorIdx] === selColor);
        }
        input.disabled = !hasAny;
      });
    }

    // Verplichte items tellen altijd mee; optionele alleen als ze aangevinkt zijn.
    isActive(card) {
      return card.dataset.optional !== 'true' || card.dataset.selected === 'true';
    }

    updateTotal() {
      let sub = 0;
      this.cards.forEach(c => { if (this.isActive(c)) sub += parseInt(c.dataset.selectedVariantPrice) || 0; });
      const final = Math.round(sub * (1 - this.pct / 100));
      const saved = sub - final;
      if (this.subtotalEl) this.subtotalEl.textContent = this.pct > 0 ? this.fmt.format(sub / 100) : '';
      if (this.finalEl) this.finalEl.textContent = this.fmt.format(final / 100);
      if (this.savingsEl) {
        this.savingsEl.textContent = (this.pct > 0 && saved > 0)
          ? '· ' + this.savingsLabel + ' ' + this.fmt.format(saved / 100)
          : '';
      }
      const required = this.cards.filter(c => c.dataset.optional !== 'true');
      const allOut = required.length > 0 && required.every(c => c.dataset.available === 'false');
      if (this.addBtn) this.addBtn.disabled = allOut;
    }

    async addAllToCart() {
      this.errorEl?.classList.remove('is-visible');
      this.addBtn?.setAttribute('aria-busy', 'true');
      // Onzichtbare properties (underscore = verborgen in cart/checkout) die de Shopify
      // discount-function uitleest. _bundle_id groepeert deze set; _bundle_req markeert de
      // vaste items; _bundle_min = aantal vereiste vaste items. Zo vervalt de korting zodra
      // je een vast item uit de bundel verwijdert (optionele items mogen weg blijven).
      const activeCards = this.cards.filter(c => this.isActive(c) && c.dataset.available === 'true');
      const fixedCount = activeCards.filter(c => c.dataset.optional !== 'true').length;
      const bundleId = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      const items = activeCards
        .map(c => {
          const props = {
            _bundle_pct: String(this.pct),
            _bundle_id: bundleId,
            _bundle_min: String(fixedCount)
          };
          if (c.dataset.optional !== 'true') props._bundle_req = '1';
          // Maatadviseur-properties (indien de koper advies toepaste op deze kaart) meesturen.
          if (c._advisorProps) Object.assign(props, c._advisorProps);
          return { id: parseInt(c.dataset.selectedVariantId), quantity: 1, properties: props };
        })
        .filter(item => !isNaN(item.id));
      if (!items.length) { this.addBtn?.removeAttribute('aria-busy'); return; }

      // Cart-drawer melden welke secties opnieuw gerenderd moeten worden.
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true, detail: { sections: sectionsToBundle }
      }));

      try {
        const add = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items })
        });
        const addJson = await add.json();
        if (!add.ok) throw new Error(addJson.description || 'Kon items niet toevoegen');

        // Bundelkorting toepassen vóór het renderen van de drawer-secties.
        if (this.code) {
          try { await fetch(`${Shopify.routes.root}discount/${this.code}`); }
          catch (e) { console.warn('Bundle discount apply failed', e); }
        }

        if (window.themeVariables?.settings?.cartType === 'page' || window.themeVariables?.settings?.pageType === 'cart') {
          window.location.href = `${Shopify.routes.root}cart`;
          return;
        }

        const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        const sections = {};
        await Promise.all(sectionsToBundle.map(async (id) => {
          sections[id] = await (await fetch(`${Shopify.routes.root}?section_id=${id}`)).text();
        }));
        cart.sections = sections;

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart }
        }));
      } catch (err) {
        if (this.errorEl) { this.errorEl.textContent = err.message; this.errorEl.classList.add('is-visible'); }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } finally {
        this.addBtn?.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('bundle-configurator', BundleConfigurator);
}
